import { useState } from "react";

const inp = {
  width: "100%",
  background: "var(--surface2)",
  border: "1px solid var(--border)",
  borderRadius: 8,
  padding: "14px 18px",
  color: "var(--text)",
  fontFamily: "'Rajdhani', sans-serif",
  fontSize: 16,
  fontWeight: 500,
  outline: "none",
  transition: "border-color 0.2s, box-shadow 0.2s",
};

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("https://formsubmit.co/ajax/csharma.bsg@gmail.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          subject: form.subject,
          message: form.message,
        }),
      });

      const result = await response.json();

      if (result.success === "true" || result.success === true) {
        setSent(true);
        setForm({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      }
    } catch (err) {
      console.error("Submission error:", err);
    }

    setLoading(false);
  };

  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh", paddingTop: 80, overflowX: "hidden" }}>
      <style>{`
        .wb-contact-section {
          padding: 80px 48px;
          max-width: 1100px;
          margin: 0 auto;
        }

        .wb-contact-grid {
          display: grid;
          grid-template-columns: 1fr 1.3fr;
          gap: 60px;
          align-items: start;
        }

        .wb-contact-form-box {
          background: var(--surface);
          border: 1px solid var(--border);
          borderRadius: 16px;
          padding: 36px 32px;
          border-radius: 16px;
          box-shadow: 0 12px 36px rgba(0, 0, 0, 0.4);
        }

        .wb-form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 16px;
        }

        .wb-inp:focus {
          border-color: var(--neon) !important;
          box-shadow: 0 0 14px rgba(0, 245, 196, 0.2);
        }

        /* Tablet (768px - 1024px) */
        @media (max-width: 1024px) {
          .wb-contact-section {
            padding: 60px 28px;
          }
          .wb-contact-grid {
            grid-template-columns: 1fr;
            gap: 48px;
          }
        }

        /* Mobile (< 640px) */
        @media (max-width: 640px) {
          .wb-contact-section {
            padding: 48px 16px;
          }
          .wb-contact-grid {
            grid-template-columns: 1fr;
            gap: 36px;
          }
          .wb-contact-form-box {
            padding: 24px 18px;
          }
          .wb-form-row {
            grid-template-columns: 1fr;
            gap: 14px;
          }
        }
      `}</style>

      <section className="wb-contact-section">
        <div className="wb-contact-grid">
          <div>
            <div
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 11,
                color: "var(--neon2)",
                letterSpacing: 3,
                textTransform: "uppercase",
                marginBottom: 14,
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <span style={{ width: 24, height: 1, background: "var(--neon2)", display: "inline-block" }} /> Contact
            </div>
            <h1
              style={{
                fontFamily: "'Orbitron', monospace",
                fontSize: "clamp(26px, 4.5vw, 44px)",
                fontWeight: 900,
                color: "var(--text)",
                marginBottom: 16,
                lineHeight: 1.1,
              }}
            >
              Get in <span style={{ color: "var(--neon2)" }}>Touch</span>
            </h1>
            <p style={{ color: "var(--muted)", fontSize: 15, lineHeight: 1.8, marginBottom: 36 }}>
              Have questions? Want to partner? Report a bug? We respond within 24 hours.
            </p>

            {[
              ["📧", "Email", "support@walkbattle.app"],
              ["🏢", "Office", "New Delhi, India"],
              ["🕐", "Response", "Within 24 hours"],
            ].map(([ic, label, val]) => (
              <div
                key={label}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  marginBottom: 16,
                  padding: "14px 18px",
                  background: "var(--surface)",
                  border: "1px solid var(--border)",
                  borderRadius: 10,
                }}
              >
                <div style={{ fontSize: 22 }}>{ic}</div>
                <div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--muted)",
                      fontFamily: "monospace",
                      textTransform: "uppercase",
                      letterSpacing: 1,
                    }}
                  >
                    {label}
                  </div>
                  <div style={{ fontSize: 15, fontWeight: 600, color: "var(--text)" }}>{val}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="wb-contact-form-box">
            {sent ? (
              <div style={{ textAlign: "center", padding: "36px 0" }}>
                <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
                <h2
                  style={{
                    fontFamily: "'Orbitron', monospace",
                    fontSize: 22,
                    fontWeight: 900,
                    color: "var(--neon)",
                    marginBottom: 10,
                  }}
                >
                  Message Sent!
                </h2>
                <p style={{ color: "var(--muted)", fontSize: 15, lineHeight: 1.7 }}>
                  We'll get back to you within 24 hours. Keep walking! 👟
                </p>
                <button
                  onClick={() => setSent(false)}
                  style={{
                    marginTop: 24,
                    background: "var(--surface2)",
                    border: "1px solid var(--border)",
                    color: "var(--muted)",
                    padding: "12px 28px",
                    borderRadius: 6,
                    cursor: "pointer",
                    fontFamily: "'Orbitron', monospace",
                    fontSize: 10,
                    letterSpacing: 2,
                    textTransform: "uppercase",
                  }}
                >
                  Send Another
                </button>
              </div>
            ) : (
              <form onSubmit={submit}>
                <h2
                  style={{
                    fontFamily: "'Orbitron', monospace",
                    fontSize: 18,
                    fontWeight: 700,
                    color: "var(--text)",
                    marginBottom: 24,
                  }}
                >
                  Send a Message
                </h2>
                <div className="wb-form-row">
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: 11,
                        color: "var(--muted)",
                        fontFamily: "monospace",
                        letterSpacing: 1.5,
                        textTransform: "uppercase",
                        marginBottom: 8,
                      }}
                    >
                      Name
                    </label>
                    <input
                      className="wb-inp"
                      style={inp}
                      placeholder="Your name"
                      value={form.name}
                      onChange={(e) => setForm({ ...form, name: e.target.value })}
                      required
                    />
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: 11,
                        color: "var(--muted)",
                        fontFamily: "monospace",
                        letterSpacing: 1.5,
                        textTransform: "uppercase",
                        marginBottom: 8,
                      }}
                    >
                      Email
                    </label>
                    <input
                      className="wb-inp"
                      style={inp}
                      type="email"
                      placeholder="you@example.com"
                      value={form.email}
                      onChange={(e) => setForm({ ...form, email: e.target.value })}
                      required
                    />
                  </div>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: 11,
                      color: "var(--muted)",
                      fontFamily: "monospace",
                      letterSpacing: 1.5,
                      textTransform: "uppercase",
                      marginBottom: 8,
                    }}
                  >
                    Subject
                  </label>
                  <input
                    className="wb-inp"
                    style={inp}
                    placeholder="What's this about?"
                    value={form.subject}
                    onChange={(e) => setForm({ ...form, subject: e.target.value })}
                    required
                  />
                </div>
                <div style={{ marginBottom: 24 }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: 11,
                      color: "var(--muted)",
                      fontFamily: "monospace",
                      letterSpacing: 1.5,
                      textTransform: "uppercase",
                      marginBottom: 8,
                    }}
                  >
                    Message
                  </label>
                  <textarea
                    className="wb-inp"
                    style={{ ...inp, minHeight: 120, resize: "vertical" }}
                    placeholder="Your message..."
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    required
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: "100%",
                    background: loading ? "var(--surface3)" : "var(--neon)",
                    color: loading ? "var(--muted)" : "var(--bg)",
                    padding: "16px",
                    borderRadius: 6,
                    border: "none",
                    fontFamily: "'Orbitron', monospace",
                    fontSize: 11,
                    fontWeight: 800,
                    letterSpacing: 2,
                    textTransform: "uppercase",
                    cursor: loading ? "not-allowed" : "pointer",
                    transition: "all 0.3s",
                    boxShadow: loading ? "none" : "0 0 20px rgba(0,245,196,0.3)",
                  }}
                >
                  {loading ? "Sending..." : "▶ Send Message"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

